import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import FileButton from "../../../UI/FileButton/FileButton";
import { UPLOAD_CONFIG, validateFileExtensions } from "../../../../Config/upload.config";
const MessageAttachmentButton = (props) => {
    // This component handles comprehensive validation including total file count across uploads
    // FileButton only validates batch size and file types, not cumulative totals
    const validateFiles = (files) => {
        // Check file count limit per batch (DoS protection)
        if (files.length > UPLOAD_CONFIG.MAX_FILES) {
            return {
                isValid: false,
                error: `Maximum ${UPLOAD_CONFIG.MAX_FILES} files can be uploaded at once. Please select fewer files and try again.`
            };
        }
        // Check total files including existing queue (prevent queue accumulation)
        const existingCount = props.existingFilesCount || 0;
        if (existingCount + files.length > UPLOAD_CONFIG.MAX_FILES) {
            return {
                isValid: false,
                error: `Cannot add ${files.length} file(s). Maximum ${UPLOAD_CONFIG.MAX_FILES} files total. Currently ${existingCount} files in queue.`
            };
        }
        // Check file extensions
        const extensionValidation = validateFileExtensions(files);
        if (!extensionValidation.isValid) {
            return {
                isValid: false,
                error: extensionValidation.error || "Invalid file type(s) selected."
            };
        }
        // Check total size across all files (30MB limit to match backend)
        const filesSize = files.reduce((sum, file) => sum + file.size, 0);
        const TOTAL_SIZE_LIMIT = 31457280; // 30MB in bytes (matches backend AttachmentService)
        const TOTAL_SIZE_LIMIT_DISPLAY = "30MB";
        if (filesSize + props.totalSize > TOTAL_SIZE_LIMIT) {
            return {
                isValid: false,
                error: `Total size of all attachments cannot exceed ${TOTAL_SIZE_LIMIT_DISPLAY}. Current size would be ${((filesSize + props.totalSize) / (1024 * 1024)).toFixed(1)}MB.`
            };
        }
        // Check individual file sizes against the effective limit for messages (30MB, not 100MB)
        for (const file of files) {
            if (file.size > TOTAL_SIZE_LIMIT) {
                return {
                    isValid: false,
                    error: `Individual file "${file.name}" cannot exceed ${TOTAL_SIZE_LIMIT_DISPLAY} for message attachments. File size: ${(file.size / (1024 * 1024)).toFixed(1)}MB.`
                };
            }
        }
        return { isValid: true };
    };
    // Get accepted file types for FileButton accept attribute
    const acceptedTypes = Object.values(UPLOAD_CONFIG.ACCEPTED_FILE_TYPES).join(',');
    return (_jsx(FileButton, { button: props.button, accept: acceptedTypes, existingFilesCount: 0, skipSizeValidation: true, onChange: (files) => {
            const validation = validateFiles(files);
            if (!validation.isValid) {
                props.onError(validation.error || "Validation failed");
            }
            else {
                const filesSize = files.reduce((sum, file) => sum + file.size, 0);
                props.onError(null); // Clear any previous errors
                props.onChange(files, filesSize);
            }
        }, onError: (error) => {
            props.onError(error);
        } }));
};
export default MessageAttachmentButton;
